naja.uiHandler.addEventListener('interaction', (event) => {
    if (event.detail.element.closest('.order-withdrawal__form')) {
        event.detail.options.history = false;
    }
});
